<mat-card>
  <mat-card-header>
    <mat-card-title>Set AWV email template</mat-card-title>
    <mat-card-subtitle>Set AWV email template for this client</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content fxLayout="column">
    <form [formGroup]="formGroup" class="email-template-form-container">
      <mat-radio-group fxLayout="column" fxLayoutGap="8px" formControlName="option">
        <mat-radio-button value="default">Default email template</mat-radio-button>
        <mat-radio-button value="custom">Custom email template</mat-radio-button>
      </mat-radio-group>
      <mat-form-field *ngIf="formGroup.value.option === 'custom'">
        <mat-label>Template id</mat-label>
        <input matInput formControlName="template_id" placeholder="Ex: d-123456abc" />
      </mat-form-field>
    </form>
  </mat-card-content>
  <mat-card-actions class="mat-card-actions">
    <button mat-button (click)="close()">Cancel</button>
    <button mat-raised-button [disabled]="disabledButton" color="accent" (click)="saveTemplateId()">Save</button>
  </mat-card-actions>
</mat-card>
